import { Link } from 'react-router-dom'

import {
  Alignment,
  Bodytext,
  Card,
  Heading,
  Popover,
} from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const Container = styled(Card)`
  align-items: center;
  margin: auto;
  max-width: 800px;
  overflow-x: hidden;
`

export const SettingsContainer = styled(Card)`
  margin: auto;
  margin-top: 20px;
  max-width: 800px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    border-radius: 0px;
    margin-top: 10px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 40px 40px;
  position: relative;
  width: 100%;
  align-items: center;
  margin-top: 50px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 35px 30px 30px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 480px;
  text-align: center;
  margin: 70px;
  margin-bottom: 0px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding-top: 30px;
    padding-bottom: 20px;
    margin: auto;
    background: ${(props) => props.theme.colors.white};
  }
`

export const HeadingStyled = styled(Heading)`
  font-size: 30px;
  margin-bottom: 10px;
  align-items: center;
  display: flex;
  text-align: center;
`

export const ShortCutsContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 35px 30px 30px;
  }
`

export const IconTitleContainer = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
`

export const RiskContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const InvestorProfileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const ThemeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const StyledBodytext = styled(Bodytext)`
  padding-left: 19px;
`

export const StyledHeaderBodyText = styled(Bodytext)`
  max-width: 450px;
  min-height: 45px;
  text-align: center;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-left: 30px;
    margin-right: 30px;
  }
`

export const StyledCurrentOptionText = styled(Bodytext)<{
  isInvest?: boolean
  isRiskText?: boolean
}>`
  padding-right: ${(props) =>
    props.isInvest === false && props.isRiskText ? '0px' : '13px'};
  color: ${style((theme) => theme.colors.green)};
  font-weight: 600;
`

export const DottedUnderline = styled.span<{ isInvest: boolean }>`
  ${(props) =>
    props.isInvest === false &&
    `
        display:inline-block;
        border-bottom: 1px dashed;
        color: ${style((theme) => theme.colors.green)};
        padding-bottom:2px;
    `}
`

export const StyledHeaderLine = styled.hr`
  border: 0.5px solid ${style((theme) => theme.colors.ivory)};
  border-radius: 0px;
  width: 100%;
  margin-top: 21px;
  margin-bottom: 21px;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  height: 22px;
`

export const ThinDivider = styled.hr`
  position: relative;
  border: 0.5px solid ${style((theme) => theme.colors.ivory)};
  box-sizing: border-box;
  border-radius: 0px;
  width: calc(100% + 80px);
  margin: 50px 50px 40px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const HorizontalDivider = styled.div`
  width: calc(100% + 80px);
  background-color: ${style((theme) => theme.colors.ivoryLight)};
  height: 10px;
  margin-top: 40px;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: 100%;
    margin-top: unset;
  }
`

export const StyledPopover = styled(Popover)<{
  tooltipAlignment: number
  currentProduct: string
}>`
  div:nth-child(2) > div {
    background-color: ${style((theme) => theme.colors.slate)};
    color: ${style((theme) => theme.colors.white)};
    border: none;
    box-shadow: ${style((theme) => theme.shadows.smMedium)};
    font-size: 12px;
    line-height: 14px;
    padding: 10px 6px;
    font-weight: 500;
    border-radius: ${style((theme) => theme.styles.smallBorderRadius)};
    margin-right: ${(props) =>
      props.tooltipAlignment === Alignment.TopRight && '15px'};
    width: ${(props) => (props.currentProduct === 'later' ? '235px' : '215px')};
    text-align: center;
    @media screen and (max-width: ${style((theme) => theme.breakpoints.md)}px) {
      width: 200px;
    }
    &::after {
      border-top-color: ${style((theme) => theme.colors.slate)};
      top: 85%;
      margin-right: 0px;
    }
  }
`

export const PurpleBadge = styled.div`
  background: #6944ff;
  border-radius: ${style((theme) => theme.styles.borderRadius)};
  color: ${style((theme) => theme.colors.white)};
  padding: 3px 11px;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 15px;
`

export const InfoNoteButton = styled.button`
  all: unset;
  cursor: pointer;
`
